import { render, staticRenderFns } from "./addCurrency.vue?vue&type=template&id=5e3adae6&scoped=true"
import script from "./addCurrency.vue?vue&type=script&lang=js"
export * from "./addCurrency.vue?vue&type=script&lang=js"
import style0 from "./addCurrency.vue?vue&type=style&index=0&id=5e3adae6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3adae6",
  null
  
)

export default component.exports